<p-menubar [model]="items"></p-menubar>

